import { render, staticRenderFns } from "./TheWelfareList.vue?vue&type=template&id=3a8f4692"
import script from "./TheWelfareList.vue?vue&type=script&lang=js"
export * from "./TheWelfareList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports